import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ApplicantDetailsComponent } from '../../../shared/components/applicant-details/applicant-details.component';
import { AddressDetailsComponent } from '../../../shared/components/address-details/address-details.component';
import { WorkrequestCmpComponent } from '../workrequest-cmp/workrequest-cmp.component';
import { LoginService } from '../../../shared/services/login.service';
import { CmpService } from '../cmp.service';
import { Router } from '@angular/router';
import { PlumberDetailsComponent } from '../../../shared/components/plumber-details/plumber-details.component';
import { UploadFile3Component } from '../../../shared/components/upload-file3/upload-file3.component';
import { Steps } from 'primeng/primeng';
import { IppaymentComponent } from '../../../shared/components/ippayment/ippayment.component';
import { IppaymentService } from '../../../shared/services/ippayment.service';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import { CmpComponent } from './cmp.component';
import { FireCmpComponent } from '../fire-cmp/fire-cmp.component';
import { WorkrequestCmpDetails } from '../workrequest-cmp-details';
import { Meta } from '@angular/platform-browser';
import { AddressService } from '../../../shared/services/address.service';
import { FeeService } from '../../../shared/services/fee.service';

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-cmp-wf',
  templateUrl: 'cmp.component.html',
  styleUrls: ['cmp.component.css'],
  entryComponents: [ApplicantDetailsComponent, AddressDetailsComponent, WorkrequestCmpComponent, PlumberDetailsComponent,
    UploadFile3Component, IppaymentComponent, FireCmpComponent],
  encapsulation: ViewEncapsulation.None
})

export class CmpWfComponent extends CmpComponent implements OnInit {
  constructor(protected loginService: LoginService, private addressService: AddressService,
    protected cmpService: CmpService, protected ipPaymentService: IppaymentService,
    protected router: Router, protected feeService: FeeService,
    private meta: Meta) {
    super(loginService, cmpService, ipPaymentService, router, feeService);
    this.meta.updateTag({ name: 'description', content: 'Request to carry out plumbing works for sewerage, water and recycled water for all non residential and multi unit residential properties with a proposed fire service.' });

    this.addressService.getPricingZone().subscribe(_pricingzone => {
      console.log(_pricingzone.toUpperCase());
      this.cwwPricingZone = (_pricingzone && _pricingzone.toUpperCase() === 'FMR CWW');
      this.updatePaymentTab(this.shouldShowPaymentInfo, 7, 'Eighth Step');
    }, err => {
      this.cwwPricingZone = true;
    });
  }

  async ngOnInit() {
    let isTokenValid = await this.loginService.isTokenValid();
    if (!isTokenValid) {
      if (this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean) => {
          this.init();
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.init();
      this.setupTabs();
      this.updatePaymentTab(this.shouldShowPaymentInfo, 7, 'Eighth Step');
    }
  }

  init(): void {
    this.fire = true;
    this.paymentActiveIndex = 7;
    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(this.paymentActiveIndex, this.workrequestComponent.totalOrderAmount);
    });
    (<WorkrequestCmpDetails>this.workRequestViewModel.workrequestDetails).fire = true;
  }

  setupTabs(): void {
    const me = this;
    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(this.cmpService.applicationData.applicant);
      this.addMenuItem('Location details', me, 0, 'First Step');
      this.addMenuItem('Work request', me, 1, 'Second Step');
      this.addMenuItem('Fire service', me, 2, 'Third Step');
      this.addMenuItem('Plumber details', me, 3, 'Fourth Step');
      this.addMenuItem('Upload plans', me, 4, 'Fifth Step');
      this.addMenuItem('Applicant details', me, 5, 'Sixth Step');
      this.addMenuItem('Review and submit', me, 6, 'Seventh Step');
    } else {
      // this.setApplicantDetailsForGuestUser(this.cmpService.applicationData.applicant);
      this.setApplicantDetailsForNonBillLater(this.cmpService.applicationData.applicant);
      this.addMenuItem('Location details', me, 0, 'First Step');
      this.addMenuItem('Work request', me, 1, 'Second Step');
      this.addMenuItem('Fire Service', me, 2, 'Third Step');
      this.addMenuItem('Plumber details', me, 3, 'Fourth Step');
      this.addMenuItem('Upload plans', me, 4, 'Fifth Step');
      this.addMenuItem('Applicant details', me, 5, 'Sixth Step');
      this.addMenuItem('Review and submit', me, 6, 'Seventh Step');
      this.addMenuItem('Payment', me, 7, 'Eighth Step');
    }
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.cmpService.submitErrorMessage = '';

    if (this.activeIndex === 0) { // location
      this.navigateFromLocation(executeYes, executeNo);
    } else if (this.activeIndex === 1) { // Work request
      this.workrequestComponent.errorMessage = null;
      const errMessage = this.workrequestComponent.displayErrorMessage();
      if (this.workrequestComponent.invalid && errMessage.length > 0) {
        this.workrequestComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 2) { // Fire
      this.fireCmpComponent.errorMessage = null;
      const errMessage = this.fireCmpComponent.displayErrorMessage();
      if (this.fireCmpComponent.invalid && errMessage.length > 0) {
        this.fireCmpComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 3) { // Plumber
      this.plumberDetailsComponent.errorMessage = null;
      if (this.plumberDetailsComponent.invalid && this.plumberDetailsComponent.displayErrorMessage().length > 0) {
        this.plumberDetailsComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 4) { // Upload
      if (this.uploadComponent.isInvalid()) {
        executeNo();
      }
      else {
        executeYes();
      }
    } else if (this.activeIndex === 5) { // Applicant
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.cmpService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
      } else {
        this.canGoNextFormLevel(executeYes, executeNo);
      }
      // } else if (this.isGuestUserLoggedIn && this.activeIndex === this.paymentActiveIndex - 1) { // on review and submit tab
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === this.paymentActiveIndex - 1) { // on review and submit tab
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/cmp/cmp-wf.component.ts